import { createFileRoute } from '@tanstack/react-router';
import { MenuTitle } from '../../types';

export const Route = createFileRoute('/_private-routes/settings')({
  staticData: {
    menuTitle: MenuTitle.Settings
  }
});
